import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Player from '@vimeo/player';
import { CancelTokenSource } from 'axios';
import Configs from 'config';
import moment from 'moment';
import ClassList from 'components/excelClass/components/ClassList';
import apiClient, { WrappingApiClient } from 'libs/api/apiClient';
import { Button } from 'antd';
import styled from 'styled-components';
import { device } from 'GlobalStyles';

type TVideo = {
  id: Number;
  title: String;
  description: Array<String>;
  video_number: Number;
  thumbnail_image: String;
  video_url: String;
  mentor_name: String;
  file: Array<{
    id: Number;
    file_name: String;
    absolute_url: String;
  } | null>;
};

const ExcelClassPlayer = () => {
  const [videos, setVideos]: any = useState();

  const { id }: any = useParams();
  const [videoNum, setVideoNum] = useState(id);

  const apiCallExcelTemplate = () => {
    if (videos) {
      return WrappingApiClient(apiClient.get(`${videos[0].file[0].absolute_url}`));
    }
  };

  const apiCallExcelVideo = () => {
    return WrappingApiClient(apiClient.get(`/community/excel_video`));
  };

  function ascendingSortVideoNum(arr: Array<TVideo>): Array<TVideo> {
    if (arr.length <= 1) return arr;

    let point = arr[0].video_number;

    let left = arr.filter((el): any => el.video_number < point);
    let right = arr.filter((el): any => el.video_number > point);

    return [...ascendingSortVideoNum(left), arr[0], ...ascendingSortVideoNum(right)];
  }

  const getExcelVideo = async () => {
    const { success, data } = await apiCallExcelVideo();

    if (success) {
      setVideos(ascendingSortVideoNum(data));
    }
  };

  useEffect(() => {
    getExcelVideo();
  }, []);

  useEffect(() => {
    isUserPlaying();
  }, [videoNum, videos]);

  function isUserPlaying() {
    try {
      if (document.querySelector('iframe')) {
        let iframe: any = document.querySelector('iframe');
        let player = new Player(iframe);

        player.on('play', function() {
          const sendDatetime = (params: any, cancel?: CancelTokenSource) => {
            return apiClient.post(`/community/play/excel_video`, params, {
              cancelToken: cancel?.token,
            });
          };
          let fullDate = new Date();

          sendDatetime({ watched_date: moment(fullDate).format('YYYY-MM-DD HH:mm:ss') });
        });
      }
    } catch (e) {}
  }

  useEffect(() => {
    setVideoNum(id);
  }, [id]);

  return (
    <StyledContainer>
      {videos && (
        <>
          <StyledPlayer>
            <div style={{ padding: '56.25% 0 0 0', position: 'relative' }}>
              {videoNum === '0' && (
                <iframe
                  src={videos[0].video_url}
                  frameBorder='0'
                  allow='autoplay; fullscreen; picture-in-picture'
                  allowFullScreen
                  style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                  title={videos[0].title}
                ></iframe>
              )}
              {videoNum === '1' && (
                <iframe
                  src={videos[1].video_url}
                  frameBorder='0'
                  allow='autoplay; fullscreen; picture-in-picture'
                  allowFullScreen
                  style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                  title={videos[1].title}
                ></iframe>
              )}
              {videoNum === '2' && (
                <iframe
                  src={videos[2].video_url}
                  frameBorder='0'
                  allow='autoplay; fullscreen; picture-in-picture'
                  allowFullScreen
                  style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                  title={videos[2].title}
                ></iframe>
              )}
            </div>
            <script src='https://player.vimeo.com/api/player.js'></script>
          </StyledPlayer>

          <StyledClassInfo>
            <ClassList isList={false} data={videos} />

            <article className='downloadTemplate'>
              <h1 className='title'>템플릿 다운로드</h1>

              <div className='templateInfo'>
                <Button
                  href={`${Configs.API_HOST}${videos[0].file[0].absolute_url}`}
                  className='outline secondary'
                  onClick={() => apiCallExcelTemplate()}
                >
                  전체 템플릿 다운로드
                </Button>
                <div className='templatePassword'>엑셀 파일 비밀번호: cs2022</div>
              </div>
            </article>
          </StyledClassInfo>
        </>
      )}
    </StyledContainer>
  );
};

export default ExcelClassPlayer;

const StyledContainer = styled.main`
  max-width: 1008px;
  margin: 100px auto;
`;

const StyledPlayer = styled.section``;

const StyledClassInfo = styled.section`
  display: flex;
  justify-content: space-between;
  margin-top: 68px;

  @media screen and ${device.lg} {
    flex-direction: column;
  }

  .downloadTemplate {
    width: 45%;

    @media screen and ${device.lg} {
      margin: 50px auto;
      width: 50%;
    }

    @media screen and ${device.md} {
      width: 80%;
    }

    .title {
      margin: 0;
      padding: 0 0 23px 0;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      font-size: 20px;
      font-weight: 900;
    }

    .templateInfo {
      display: flex;
      align-items: center;
      margin-top: 20px;

      @media screen and ${device.lg} {
        flex-direction: column;
        align-items: flex-start;
      }
    }

    .ant-btn {
      margin-right: 30px;

      @media screen and ${device.lg} {
        margin: 0 0 10px 0;
      }
    }

    .templatePassword {
      font-size: 11px;
    }
  }
`;
